<div class="u-border-radius test-equipment-reference__box u-padding-10 u-margin-top-30 color-background-box">
  <span class="u-font-weight-500 u-font-size-14">References:</span>
  <ul class="test-equipment-reference--ul-item-padding">
    <li *ngFor="let link of referenceConfig">
      <a class="u-color-blue" target="_blank" [href]="link.url">{{link.title}}</a>
    </li>
  </ul>
</div>
